<template lang="pug">
.overflow-hidden.white.relative.full-width
  template(v-if="loading")
    v-overlay.filter-blur-1(
      color="redesignBackground"
      :opacity="0.2"
      :z-index="10"
    )
      v-progress-circular(
        color="redesignPrimary"
        indeterminate
      )
  template(v-if="activeState === constants.STATE_CONTENT.CROPPER")
    redesign-image-cropper.rounded-0(
      title=""
      :aspect-ratio="16/9"
      multiple
      @noImages="noImagesAction"
      @cropAll="saveCroppedImages"
    )
      template(#subheader="{ editableImage }")
        .body-1(v-if="!editableImage")
          v-icon(
            color="redesignError"
            left
          ) $iinfo
          | Принимаются изображения следующих форматов: .jpg, .png, .jpeg.
          | Максимальный размер изображения - 5Мб

  template(v-if="activeState === constants.STATE_CONTENT.PREVIEW")
    div
      images-list(
        :images="event.images"
        @makeMain="makeMain"
        @deleteImage="deleteImage"
      )
      .d-flex.justify-center.mt-7.gap-16
        app-button.redesignPrimary--text.rounded-12(
          color="white"
          :height="40"
          outlined
          @click="changeActiveState(constants.STATE_CONTENT.CROPPER)"
        )
          v-icon(
            color="redesignPrimary"
            :size="22"
            left
          ) $iplus-outline
          | Добавить файлы

        app-button.white--text(
          color="redesignPrimary"
          :height="40"
          @click="closeDialog"
        ) Сохранить и закрыть
</template>

<script>
import RedesignDialog from '@/components/user-redesign/dialogs/RedesignDialog.vue';
import RedesignImageCropper from '@/components/user-redesign/inputs/RedesignImageCropper.vue';
import ImagesList from '@/components/user-redesign/ImagesList.vue';
import { dataURItoBlob } from '@/helpers/files';

export const STATE_CONTENT = {
  CROPPER: 0,
  PREVIEW: 1,
};

export default {
  components: {
    RedesignDialog,
    ImagesList,
    RedesignImageCropper,
  },
  props: {
    event: { type: Object, required: true },
    baseState: {
      type: Number,
      default: STATE_CONTENT.CROPPER,
    },
    isReplacingImage: { type: Boolean, default: false },
  },
  data() {
    return {
      activeState: this.baseState,
      loading: false,
    };
  },
  computed: {
    constants() {
      return {
        STATE_CONTENT,
      };
    },
  },
  mounted() {
    this.activeState = this.baseState;
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    noImagesAction() {
      if (this.event.images.length > 0 && !this.isReplacingImage) this.changeActiveState(STATE_CONTENT.PREVIEW);
    },
    changeActiveState(state) {
      this.activeState = state;
    },
    saveCroppedImages(images) {
      this.addImages(images.map((data) => dataURItoBlob(data)));
    },
    async addImage(img, isMain = false) {
      const { response, error } = await this.$rApi.upload.uploadFile({ args: [img] });
      if (!error) {
        const imageResponse = await this.event.addImage(response.data.data.file_name, isMain);
        return imageResponse?.data.data || null;
      }
      return null;
    },
    async addImages(images) {
      if (this.isReplacingImage) {
        await this.deleteFirstImage();
      }
      this.loading = true;
      const bullets = images.map((image) => this.addImage(image));
      Promise.all(bullets).then((promisedImages) => {
        this.$nextTick(() => {
          this.loading = false;
          const message = promisedImages.length > 1 ? 'Обложки добавлены' : 'Обложка добавлена';
          this.$toast.success(message);
          if (this.event.images.length <= 1) this.closeDialog();
          else this.changeActiveState(STATE_CONTENT.PREVIEW);
        });
      });
    },
    async deleteImage(image) {
      this.loading = true;
      const { response } = await this.event.deleteImage(image.id);
      this.loading = false;
      if (!this.isReplacingImage) this.$toast.success('Обложка удалена');
      if (!this.event.images.length) this.closeDialog();
      return response;
    },
    deleteFirstImage() {
      const [firstImage] = this.event.images;
      return this.deleteImage(firstImage);
    },
    async makeMain(image) {
      this.loading = true;
      await this.event.makeMainImage(image.id);
      this.loading = false;
    },
  },
};
</script>
